<template>
  <div class="grid-container">
    <div
      id="perks-section"
      class="lh-element-topborder margin-bottom-m lh-container-custom-gutters"
      :class="brand === 'mcom' ? 'padding-top-l' : 'padding-top-m'"
    >
      <div
        v-if="brand === 'bcom'"
        class="margin-bottom-xs grid-x align-bottom"
      >
        <h3>
          {{ title }}
        </h3>
      </div>
      <div class="lty-my-perks-points-container">
        <div class="lty-my-perks-points grid-y grid-padding-y">
          <PerkTierNote :title="title" />
          <Perk
            :perk="perkHeaderRow"
            :is-header="true"
          />
          <Perk
            v-for="perk in perks"
            :key="perk.id"
            :perk="perk"
            :is-header="false"
            @click="handleClickToPointScroll($event, emit)"
          />
        </div>
      </div>
      <div class="lty-my-perks-footer-container">
        <div class="small margin-top-s">
          {{ PERKS_CONDITION }}
        </div>
        <div class="lty-perk-exclusions small margin-top-xxs">
          <a href="#exclusions-title">{{ SEE_EXCLUSIONS }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { brand, PERKS_LIST, TIER_NAME } from '../../config';
import { useKillswitchesStore } from '../../stores/useKillswitchesStore';
import perksData from './perksList.json';
import Perk from './Perk';
import PerkTierNote from './PerkTierNote';
import { handleClickToPointScroll } from '../../utils/scrollToPointUtil';

/** Perks Component for MCOM/BCOM
 * MCOM - Bronze, Silver, Gold, Platinum
 * BCOM - Loyalist, TopOfTheList, UnLocked
 * AMEX - Offers Benefit Should Render on Conditional Base.
 */

const { perksTitle, SEE_EXCLUSIONS, PERKS_CONDITION } = PERKS_LIST;

const title = perksTitle;
const { perks: rawPerks } = perksData[brand];
const perkHeaderRow = {
  perkTitle: '',
  ...TIER_NAME,
};

const emit = defineEmits(['scroll-to-exclusion-details']);
const killswitchesStore = useKillswitchesStore();
const triplePointUpgradeEnabled = computed(() => killswitchesStore.triplePointsDayBenefitUpdateEnabled === true);
const perks = computed(() => {
  if (brand === 'mcom' || !triplePointUpgradeEnabled.value) {
    return rawPerks;
  }

  return rawPerks.map((perk) => {
    if (perk.id === 2) {
      return {
        ...perk,
        TOL: 4,
        UNL: 5,
      };
    }
    return perk;
  });
});
</script>




<style lang="scss" scoped>
.custom-margin-bottom-2 {
  margin-bottom: 2px;
}
@include breakpoint(small down) {
  .lty-my-perks-points-container {
    overflow-x: auto;
    .lty-my-perks-points {
      min-width: rem-calc(612);
    }
  }
}
#perks-section:deep(sup) {
  cursor: pointer;
}


@import '~@core/csg/src/scss/settings/bcom.scss';
h3 {
  letter-spacing: $h3-letter-spacing;
}
</style>